var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6532 0C38.4128 0 40.6532 2.24039 40.6532 5V35C40.6532 37.7596 38.4128 40 35.6532 40H5.6532C2.89359 40 0.653198 37.7596 0.653198 35V5C0.653198 2.24039 2.89359 0 5.6532 0H35.6532ZM5.42296 13.9584H12.123V34.1116H5.42296V13.9584ZM8.8182 4.24062C6.52593 4.24062 5.0282 5.74766 5.0282 7.72289C5.0282 9.65664 6.48039 11.2052 8.72953 11.2052H8.77281C11.109 11.2052 12.5631 9.65664 12.5631 7.72289C12.5198 5.74766 11.1091 4.24062 8.8182 4.24062ZM22.5284 16.8117C23.4198 15.4389 25.0116 13.4845 28.5655 13.4845C32.973 13.4845 36.278 16.3641 36.278 22.5545V34.1116H29.5795V23.3288C29.5795 20.6207 28.6089 18.772 26.1861 18.772C24.3355 18.772 23.2326 20.0182 22.7491 21.2213C22.5716 21.6519 22.5283 22.2541 22.5283 22.8566V34.1116H15.8301C15.8301 34.1116 15.9189 15.8488 15.8301 13.9584H22.5284V16.8117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedin);
export default __webpack_public_path__ + "static/media/social-linkedin.6e231618514f01638740d2577b76cb9f.svg";
export { ForwardRef as ReactComponent };